var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.973841 1.53146C2.98678 3.18455 6.51887 6.09283 7.557 6.99964C7.69636 7.12203 7.84583 7.18425 8.00101 7.18425C8.15587 7.18425 8.30508 7.12261 8.44413 7.00081C9.48314 6.09311 13.0152 3.18455 15.0282 1.53146C15.1535 1.42874 15.1726 1.24818 15.0712 1.1226C14.8366 0.832405 14.4869 0.666016 14.1121 0.666016H1.88991C1.51513 0.666016 1.1654 0.832405 0.930873 1.12263C0.829409 1.24818 0.848516 1.42874 0.973841 1.53146Z",
    fill: "#9696CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1559 2.42801C15.0476 2.37913 14.9202 2.39618 14.8301 2.47085C12.5978 4.30591 9.74872 6.65808 8.85234 7.44133C8.34923 7.88172 7.65099 7.88172 7.14671 7.44075C6.19125 6.60597 2.99186 3.96852 1.16958 2.47082C1.07886 2.39615 0.951158 2.37968 0.843736 2.42799C0.735741 2.47663 0.666504 2.58138 0.666504 2.69682V10.1482C0.666504 10.8019 1.21464 11.3334 1.88874 11.3334H14.111C14.785 11.3334 15.3332 10.8019 15.3332 10.1482V2.69682C15.3332 2.58138 15.2639 2.47635 15.1559 2.42801Z",
    fill: "#9696CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.02e2b8c7.svg";
export { ForwardRef as ReactComponent };